/*
  You can NOT currently use any component requiring REDUX STORE here because the PAGE is what contains the REDUX STORE
  So REDUX STORE is one CHILD below. Page will complain.
  What you need to do is use => `const { initialProps, initialState, store: ReduxStore } = pageProps`
  - pageProps ( contains Page information )
    - isServer: boolean
    - initialProps: Page return values ( dataLayer, metaData, etc...)
    - initialState: Flat Redux Store Object
    - store: Redux Store ( dispatch, subscribe, getState, etc... )
*/

import React, { useEffect } from 'react'
import { AppProps } from 'next/app'
import { trackCoreWebVitals } from 'lib/webVitals'
// @ts-ignore
import 'sass/global.scss'
import useClearLocalStorage from 'hooks/clearLocalStorage'
import useNextHeadCountGuard from 'hooks/useNextHeadCountGuard'
import useBotDetection from 'hooks/useBotDetection'
import AppMetadata from 'components/MetaData/AppMetadata'
import AppMetaFallbacks from 'components/MetaData/AppMetaFallbacks'
import AppGeoMetadata from 'components/MetaData/AppGeoMetadata'
import AppGlobalSchema from 'components/MetaData/AppGlobalSchema'
import AppHoneyPot from 'components/Honeypot/AppHoneyPot'

// Re-exported so Next.js can pick it up and report its custom timing metrics.
export { reportWebVitals } from 'lib/webVitals'
// calling the track core web vitals
trackCoreWebVitals()

type Props = AppProps<Record<string, any>> & { err?: Error }

function MyApp({ Component, pageProps, err, router }: Props) {
  const { initialProps, initialState } = pageProps

  useNextHeadCountGuard()
  useBotDetection()

  useEffect(() => {
    useClearLocalStorage()
  }, [])

  return (
    <>
      <AppGlobalSchema initialProps={initialProps} initialState={initialState} router={router} />
      <AppMetaFallbacks initialProps={initialProps} initialState={initialState} router={router} />
      <AppMetadata initialProps={initialProps} initialState={initialState} router={router} />
      <AppGeoMetadata initialProps={initialProps} initialState={initialState} router={router} />
      <AppHoneyPot initialState={initialState} router={router} />
      <Component {...{ ...pageProps, err }} />
    </>
  )
}

export default MyApp
